import GlassCredit from './GlassCredit';

export default class GlassCredits {
	constructor() {

		document.addEventListener('bless', ({ detail }) => {
            this.container = detail.next.container;
			this.init();
		});
	}

	init() {

        const credits = this.container.querySelectorAll('[data-glass-credits]');
		credits.forEach(elm => {
			new GlassCredit(elm);
		});

	}
}
